import {call, put, takeLatest} from 'redux-saga/effects';

import errorActions from '../actions/error.actions';
import configActions from '../actions/config.actions';
import FGOnboardingStatusApi from '../api/FGOnboardingStatusApi';
import FGTimeRangeWarningApi from '../api/FGTimeRangeWarningApi';

function* setAppConfigFGOnboarding(action) {
    try {
        const {data} = yield call(FGOnboardingStatusApi.complete, action.payload);
        yield put(
            configActions.setAppConfigFGOnboardingSuccess({
                data
            })
        );
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(configActions.setAppConfigFGOnboardingFailed(e));
    }
}

function* setTimeRangeWarningState(action) {
    try {
        const {data} = yield call(FGTimeRangeWarningApi.update, action.payload);
        yield put(
            configActions.setTimeRangeWarningStateSuccess({
                data
            })
        );
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(configActions.setTimeRangeWarningStateFailed(e));
    }
}

function* configSaga() {
    yield takeLatest(configActions.TYPES.SET_APP_CONFIG_FG_ONBOARDING, setAppConfigFGOnboarding);
    yield takeLatest(configActions.TYPES.SET_TIME_RANGE_WARNING_STATE, setTimeRangeWarningState);
}

export default configSaga;
